module.exports = __webpack_public_path__ + "img/Frame-53.a3214164.svg";